module.exports = __webpack_public_path__ + "static/trimex-outdoor-mobile-tours-93d9db69c423bfd3592395d1748bbe4c.pdf";